const TRAINING_AUTH_DOMAIN = 'trainingAuth'
const TRAINING_AUTH_KEY = {
  EMAIL_OR_NAME: 'emailOrName',
  EMAIL: 'email',
  PASSWORD: 'password',
  IS_SIGN_UP: 'isSignUp'
}

const TRAINING_AUTH_ENDPOINT = {
  AUTHENTICATE: '/auth',
  LOG_OUT: '/auth/log-out',
  LOG_IN: '/auth/log-in',
  LOG_IN_WITH_FACEBOOK: '/auth/log-in-with-facebook',
  SIGN_UP: '/auth/sign-up',
  CHECK_IF_EMAIL_EXIST: '/auth/exists',
  RESET_PASSWORD: '/users/reset-password'
}

const TRAINING_AUTH_ACTION = {
  AUTHENTICATE: 'TRAINING_AUTH_AUTHENTICATE',
  UPDATE_JWT: 'TRAINING_AUTH_UPDATE_JWT',
  LOG_IN: 'TRAINING_AUTH_LOG_IN',
  LOG_OUT: 'TRAINING_AUTH_LOG_OUT',
  SAVE: 'TRAINING_AUTH_SAVE',
  LOG_IN_WITH_FACEBOOK: 'TRAINING_AUTH_LOG_IN_WITH_FACEBOOK',
  SIGN_UP: 'TRAINING_AUTH_SIGN_UP',
  VALIDATE_EMAIL_AND_PASSWORD: 'TRAINING_AUTH_VALIDATE_EMAIL_AND_PASSWORD',
  UPDATE_PASSWORD: 'TRAINING_AUTH_UPDATE_PASSWORD',
  UPDATE_TO_LOG_IN: 'TRAINING_AUTH_UPDATE_TO_LOG_IN',
  UPDATE_TO_SIGN_UP: 'TRAINING_AUTH_UPDATE_TO_SIGN_UP',
  UPDATE_AND_VALIDATE: 'TRAINING_AUTH_UPDATE_AND_VALIDATE',
  VALIDATE_RESET_PASSWORD_EMAIL: 'TRAINING_AUTH_VALIDATE_RESET_PASSWORD_EMAIL',
  RESET_STATE: 'TRAINING_AUTH_RESET_STATE',
  CHECK_IF_EMAIL_EXIST: 'CHECK_IF_EMAIL_EXIST',
  RESET_PASSWORD: 'RESET_PASSWORD'
}

const TRAINING_AUTH_STATE = {
  changed: {
    [TRAINING_AUTH_KEY.EMAIL_OR_NAME]: '',
    [TRAINING_AUTH_KEY.EMAIL]: '',
    [TRAINING_AUTH_KEY.IS_SIGN_UP]: true,
    [TRAINING_AUTH_KEY.PASSWORD]: ''
  },
  data: {},
  error: null,
  status: null,
  validation: null
}

export {
  TRAINING_AUTH_DOMAIN,
  TRAINING_AUTH_KEY,
  TRAINING_AUTH_ACTION,
  TRAINING_AUTH_ENDPOINT,
  TRAINING_AUTH_STATE
}
